import { render, staticRenderFns } from "./upchatDialog.vue?vue&type=template&id=c62c12f8&lang=pug"
import script from "./upchatDialog.vue?vue&type=script&lang=js"
export * from "./upchatDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports